import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import LogoComponent from './topics-logo-image-url.component';
import CoverimageComponent from './chapters-cover-image-url.component';

export const TopicsBasicInfoComponent = ({
    selectedTopics, handleInnerFormChange, chapters,changeCoverImage, libraryData, changeLogoImage
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>


                        <InputContainer
                            label="Community Chapter"
                            labelField="Name"
                            list={chapters}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CommunityChapterId'
                                )
                            }}
                            optionName='Choose Chapter'
                            type="select"
                            value={selectedTopics?.CommunityChapterId}
                            valueField="Id"
                        />

                        <InputContainer
                            label="Topic Type"
                            labelField="Description"
                            list={libraryData}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'TopicTypeId'
                                )
                            }}
                            optionName='Choose Topic Type'
                            type="select"
                            value={selectedTopics?.TopicTypeId}
                            valueField="Value"
                        />

                        <InputContainer
                            label="Subject"
                            name="Subject"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Subject'
                                );
                            }}
                            type="text"
                            value={selectedTopics?.Subject}
                        />

                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
            <AccordionContainer
                child={
                    <div>
                        <LogoComponent
                            selectedTopics={selectedTopics}
                            changeLogoImage={changeLogoImage}
                        />

                    </div>
                }
                expandedPanel="logo"
                headerTitle="Logo Info"
            />

             <AccordionContainer
                child={
                    <div>
                        <CoverimageComponent
                            selectedTopics={selectedTopics}
                            changeCoverImage={changeCoverImage}
                        />

                    </div>
                }
                expandedPanel="Cover"
                headerTitle="Coverimage Info"
            />
        </>
    )
}

export default TopicsBasicInfoComponent;
